module.exports = __webpack_public_path__ + "static/forms-layout-dont-341c652ec370a0acbaafae6ee1b67674.png";